import { JobType } from "@leedpulse-monorepo/enums";

export class ScenarioSample {
  private _type: JobType;
  private _message: string;
  private _context: string;

  constructor(type: JobType, message: string, context?: string) {
    this._type = type;
    this._message = message;
    this._context = context ?? '';
  }

  get type(): JobType {
    return this._type;
  }

  get message(): string {
    return this._message;
  }

  get context(): string {
    return this._context;
  }

  copyWith(changes: Partial<{ type: JobType; message: string; context?: string }>): ScenarioSample {
    return new ScenarioSample(
      changes.type ?? this._type,
      changes.message ?? this._message,
      changes.context ?? this._context
    );
  }

  static fromFirestoreMap(data: any): ScenarioSample {
    return new ScenarioSample(data.type as JobType, data.message, data.context ?? undefined);
  }

  toFirestoreMapPatch(): Record<string, any> {
    return {
      type: this._type,
      message: this._message,
      context: this._context,
    };
  }
}
